import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const InfluencerSignUp = () => {
  const [userdata, setuserdata] = useState({
    fullname: "", phone: "", email: "", password: "",
    instagramURL: "", facebookURL: "", twitterURL: "", city: "", state: "", country: ""
  });
  const [cpass, setcpass] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [passwordConfirmType, setPasswordConfirmType] = useState("password");

  const navigate = useNavigate();

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const toggleConfirmPassword = () => {
    setPasswordConfirmType(passwordConfirmType === "password" ? "text" : "password");
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setuserdata({ ...userdata, [name]: value });
  };

  const handleConfirmPassword = (e) => {
    setcpass(e.target.value);
  };

  const postData = async (e) => {
    e.preventDefault();
    const { fullname, phone, email, password, instagramURL, facebookURL, twitterURL, city, state, country } = userdata;

    if (password === cpass) {
      try {
        const res = await fetch("https://server-side-influencer.onrender.com/influencer/signup", {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fullname, phone, email, password, instagramURL, facebookURL, twitterURL, city, state, country
          }),
        });

        const data = await res.json();

        if (res.ok) {
          toast.success(data.message);
          setTimeout(() => {
            navigate("/InfluencerLogin");
          }, 2200);
        } else {
          toast.error(data.error);
        }
      } catch (error) {
        toast.error("An error occurred while submitting your data.");
      }
    } else {
      toast.error("Passwords do not match!");
    }
  };

  return (
    <div className="flex flex-col justify-center items-center font-[sans-serif] bg-gradient-to-r from-purple-600 to-blue-500 lg:h-screen p-6">
      <div className="grid md:grid-cols-2 items-center gap-y-8 bg-white max-w-7xl w-full shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)] rounded-md overflow-hidden">

        {/* Left Section with Logo and Intro */}
        <div className="max-md:order-1 flex flex-col justify-center items-center sm:p-8 p-4 bg-gradient-to-br from-purple-600 to-blue-500 w-full h-full">
          <div className="max-w-md space-y-8 text-center flex flex-col items-center justify-center">
            {/* Logo and Text Centered */}
            <div className="flex items-center justify-center gap-2 mb-4">
              <img 
                src="https://i.postimg.cc/Rhd5hYcN/halfolog-removebg-preview.png" 
                alt="Influenceso Logo" 
                className="h-12 w-auto"
              />
              <span className="text-white font-bold text-2xl mt-2">INFLUENCESO</span>
            </div>

            <div>
              <h4 className="text-white text-3xl font-semibold mb-2">Create Your Account</h4>
              <p className="text-lg text-white mt-3">
                Welcome to Influenceso registration page! Get started by creating your account as influencer and collaborate with brands.
              </p>
            </div>
          </div>
        </div>

        {/* Right Side Form */}
        <form className="sm:p-8 p-4 w-full overflow-y-auto max-h-[80vh]" onSubmit={postData}>
          <div className="mb-8">
            <h3 className="text-black-500 text-3xl font-extrabold max-md:text-center">Register As Influencer</h3>
          </div>

          <div className="grid lg:grid-cols-2 gap-4">
            {[ 
              { label: "Full Name", name: "fullname" },
              { label: "Contact Number", name: "phone" },
              { label: "Email Address", name: "email", type: "email" },
              { label: "Instagram URL", name: "instagramURL", type: "url" },
              { label: "Facebook URL", name: "facebookURL", type: "url" },
              { label: "Twitter URL", name: "twitterURL", type: "url" },
              { label: "City", name: "city" },
              { label: "State", name: "state" },
              { label: "Country", name: "country" },
            ].map(({ label, name, type = "text" }) => (
              <div key={name}>
                <label className="text-gray-800 text-sm mb-1 block">{label}</label>
                <input
                  name={name}
                  type={type}
                  className="bg-gray-100 w-full text-gray-800 text-sm px-4 py-2 rounded-md outline-blue-500"
                  placeholder={`Enter ${label.toLowerCase()}`}
                  value={userdata[name]}
                  onChange={handleInput}
                />
              </div>
            ))}

            {/* Password */}
            <div>
              <label className="text-gray-800 text-sm mb-1 block">Password</label>
              <input
                name="password"
                type={passwordType}
                className="bg-gray-100 w-full text-gray-800 text-sm px-4 py-2 rounded-md outline-blue-500"
                placeholder="Enter password"
                value={userdata.password}
                onChange={handleInput}
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label className="text-gray-800 text-sm mb-1 block">Confirm Password</label>
              <input
                name="cpass"
                type={passwordConfirmType}
                className="bg-gray-100 w-full text-gray-800 text-sm px-4 py-2 rounded-md outline-blue-500"
                placeholder="Confirm password"
                value={cpass}
                onChange={handleConfirmPassword}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="w-full text-white py-3 px-8 rounded-md bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:outline-none focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-800 transition-all"
              style={{ height: '50px' }}
            >
              Register
            </button>
          </div>

          <p className="text-sm text-gray-500 text-center mt-4">
            Already have an account?{" "}
            <Link to="/InfluencerLogin" className="text-blue-600 font-medium hover:underline">
              Login here
            </Link>
          </p>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default InfluencerSignUp;